module.exports = __webpack_public_path__ + "imgs/MPP.c01db5cd6a381c86003309090bbc9127.png";